function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { a11y } from "./a11y";
import { colors } from "./color";
import { colors as capioColors } from "./themes/capio/semanticColors";
import { elevations } from "./elevation";
import { spacing } from "./spacing";
import { createTypography } from "./typography";
import { borderRadiuses, createBorders } from "./border";
import { useTheme } from '@emotion/react';
import { breakpoints } from "./breakpoint";
import { WhiteLabeledThemeSchema } from "./themes/schema";

// Don't export this variable outside this file.  For [information
// hiding](https://en.wikipedia.org/wiki/Information_hiding) purposes, it's not
// meant to be exported
var fullThemeKey = Symbol('Full Theme');
var themeBase = {
  a11y: a11y,
  borders: createBorders(colors),
  borderRadiuses: borderRadiuses,
  breakpoints: breakpoints,
  elevations: elevations,
  typography: createTypography(),
  zIndex: {
    drawer: {
      context: 1700,
      overlay: 1710,
      content: 1720
    },
    dialog: {
      context: 1800,
      overlay: 1810,
      content: 1820
    },
    popover: 1900,
    menu: 2000,
    tooltip: 2100,
    toasts: 2200
  }
};

// Anything we put here is accessible to consumers.  So lets be extremely
// careful and treat this like a public API.
//
// Anything we add here is much harder to change, so we should try to be as
// confident as possible anything we add here won't have breaking changes later.
//
// Lets minimize what we put here and only add stuff once a use-case comes up
var publicLightTheme = {
  colors: colors,
  spacing: spacing
};
var publicCapioTheme = {
  colors: capioColors,
  spacing: spacing
};

// Anything we put here is completely hidden to consumers.  So it's not nearly
// as big of a deal to add stuff here, but we should still try to keep a
// well-organized private theme.  This is called [Information
// Hiding](https://en.wikipedia.org/wiki/Information_hiding) in computer science
var privateLightTheme = _objectSpread({}, themeBase);
var privateCapioTheme = _objectSpread({}, themeBase);
var fullLightTheme = _objectSpread(_objectSpread({}, publicLightTheme), privateLightTheme);
var fullCapioTheme = _objectSpread(_objectSpread({}, publicCapioTheme), privateCapioTheme);

// This is a fancy way of hiding the full theme on the public theme using
// Symbol.  As-long as we don't export `fullThemeKey` outside of this file then
// consumers won't be able to see or access the private theme properties.  See
// more info at these links:
// - https://github.com/ApplyBoard/platform_monorepo_ui/pull/3725#discussion_r933332242
// - https://applyboard.atlassian.net/wiki/spaces/UE/pages/2664137136/DRAFT+Crystal+2.0+Theming+API#Theme-API-Design
// @ts-expect-error Ignore this error because we want full theme to be hidden from consumers
publicLightTheme[fullThemeKey] = fullLightTheme;
// @ts-expect-error Ignore this error because we want full theme to be hidden from consumers
publicCapioTheme[fullThemeKey] = fullCapioTheme;
/**
 * Creates a theme depending on the mode supplied
 * (dark mode is not supported yet)
 */
export function createTheme() {
  var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'light';
  if (mode === 'light') return publicLightTheme;
  if (mode === 'capio') return publicCapioTheme;
  if (_typeof(mode) === 'object') {
    var parseResult = WhiteLabeledThemeSchema.safeParse(mode);
    if (!parseResult.success) {
      console.error(parseResult.error.message);
      return publicLightTheme;
    }
    return _objectSpread(_objectSpread({}, publicLightTheme), {}, _defineProperty({
      colors: parseResult.data.colors
    }, fullThemeKey, _objectSpread(_objectSpread({}, fullLightTheme), {}, {
      colors: parseResult.data.colors,
      typography: createTypography({
        fontFamily: parseResult.data.fontFamilies
      })
    })));
  }
  throw new Error("".concat(mode, " mode is not supported yet"));
}
/**
 * Gets the hidden full theme from the public theme.
 *
 * @note Do not export this function outside crystal-ui
 * @param theme The public crystal-ui theme
 * @returns The full crystal-ui theme with all private properties
 */
export function full(theme) {
  // @ts-expect-error Ignore this error because we want full theme to be hidden
  var fullTheme = theme[fullThemeKey];
  if (!fullTheme) {
    throw new Error('A properly structured crystal-ui theme was not provided');
  }
  return _objectSpread(_objectSpread({}, fullTheme), {}, {
    borders: createBorders(fullTheme.colors)
  });
}

/**
 * Gets the hidden full theme from the public theme in the react context.
 *
 * @returns The full crystal-ui theme with all private properties
 */
export function useFullTheme() {
  var publicTheme = useTheme();
  return full(publicTheme);
}